import { render, staticRenderFns } from "./RegionEmbed.vue?vue&type=template&id=0b440a66&"
import script from "./RegionEmbed.vue?vue&type=script&lang=js&"
export * from "./RegionEmbed.vue?vue&type=script&lang=js&"
import style0 from "./RegionEmbed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports